import { motion } from "framer-motion";

const PRESENTATION_IMAGE =
  "https://images.pexels.com/photos/34787747/pexels-photo-34787747.jpeg?auto=compress&cs=tinysrgb&w=1400";

const reveal = {
  hidden: { opacity: 0, y: 28 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.75, ease: [0.22, 1, 0.36, 1] } },
};

export const Presentation = () => {
  return (
    <section id="apropos" data-testid="presentation-section" className="bg-white">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-4 py-20 sm:px-8 lg:grid-cols-12 lg:gap-16 lg:px-16 lg:py-28">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          variants={reveal}
          className="lg:col-span-6"
        >
          <p className="mb-5 flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.28em] text-brand">
            <span className="font-display text-sm tracking-normal text-slate-400">01</span>
            <span className="h-px w-8 bg-sun" aria-hidden="true" />
            Notre approche
          </p>
          <h2
            data-testid="presentation-title"
            className="font-display text-3xl font-normal leading-tight tracking-tight text-ink sm:text-4xl lg:text-[2.75rem]"
          >
            Une rénovation complète, du début à la fin
          </h2>
          <div className="mt-7 space-y-5 text-base leading-relaxed text-slate-600 sm:text-lg">
            <p>
              Nous coordonnons les différentes étapes de votre rénovation, de la planification
              initiale jusqu’aux dernières finitions.
            </p>
            <p>
              Nous sommes à votre écoute, nous étudions les possibilités de votre logement et nous
              vous proposons des solutions pratiques pour rénover et améliorer vos espaces.
            </p>
            <p>
              Notre objectif est de vous offrir un processus clair et organisé, avec un interlocuteur
              unique pour l’ensemble de votre projet.
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 36 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.85, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
          className="relative lg:col-span-6"
        >
          <div className="overflow-hidden rounded-sm border border-slate-200 shadow-[0_24px_60px_rgba(15,23,42,0.08)]">
            <img
              src={PRESENTATION_IMAGE}
              alt="Salle de bains en cours de rénovation dans un appartement à Genève"
              data-testid="presentation-image"
              className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out hover:scale-[1.03]"
              loading="lazy"
            />
          </div>
          <div
            aria-hidden="true"
            className="absolute -bottom-4 -left-4 -z-10 h-full w-full rounded-sm border border-brand/20"
          />
        </motion.div>
      </div>
    </section>
  );
};
